import { Form } from 'antd';
import { useEffect } from 'react';
import { useApplicationContext } from '@/context/v1/Application/context';

interface OrganizationProps {
	fieldName?: string | string[];
}

const { useFormInstance, useWatch } = Form;

export function useOrganization({ fieldName }: OrganizationProps) {
	const form = useFormInstance();
	const { organization } = useApplicationContext();

	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const organizationId = useWatch(field ? [field, 'organization_id'] : 'organization_id');

	useEffect(() => {
		if (organization?.id && !organizationId) {
			form.setFieldValue(field ? [field, 'organization_id'] : ['organization_id'], organization.id);
		}
	}, [organization?.id, organizationId, form, field]);

	const items = organization?.id
		? [
				{
					value: organization.id,
					label: organization.name
				}
			]
		: [];

	return {
		items,
		organizationId: organizationId || organization?.id
	};
}
